// TODO If applicable, add Vimeo video check. See previous commits of this document.
const modalButtons = document.querySelectorAll('.usa-button--modal');
const modalClose = document.querySelectorAll('.usa-modal__close');
const modalVideo = document.querySelector('.usa-modal__main iframe');

// const playVideo = () => {
//   if (modalVideo.contentWindow) {
//     // Play Videos
//     modalVideo.contentWindow.postMessage
//     ('{ "event":"command", "func":"playVideo", "args":"" }', '*');
//   }
// };

// Pause video
const pauseVideo = () => {
  if (modalVideo.contentWindow) {
    // YouTube only
    modalVideo.contentWindow.postMessage('{ "event": "command", "func": "stopVideo", "args":"" }', '*');
  }
};

if (modalVideo !== null) {
  // Play video if modal button is clicked
  // modalButtons.forEach((e) => {
  //   e.addEventListener('click', () => {
  //     console.log('button modal clicked');
  //     playVideo();
  //   });
  // });

  // Pause video when close button is clicked
  if (modalVideo.length > 0) {
    document.addEventListener('DOMContentLoaded', (event) => {
      modalClose.forEach((e) => {
        e.addEventListener('click', () => {
          pauseVideo();
        });
      });
    });
  }

  // Pause video if esc key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      // Currently this only works if the focus is outside the iframe
      pauseVideo();
    }
  });

  // Set up observer for dynamic modal overlay
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const modalOverlay = document.querySelectorAll('.usa-modal-overlay');

        if (modalOverlay) {
          modalOverlay.forEach((e) => {
            e.addEventListener('click', () => {
              pauseVideo();
            });

            // Disconnect the observer if no longer needed
            observer.disconnect();
          });
        }
      }
    });
  });

  // Configuration for the observer
  const config = { childList: true, subtree: true };

  // Start observing the target node for configured mutations
  observer.observe(document.body, config);
}

// Open soft gate modal on pageload and set sessionStorage key/value
const softGateButton = document.querySelector('.usa-button--soft-gate');

if (softGateButton) {
  // Observer callback function to handle modal overlay detection
  const handleMutations = (mutations, observer) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const modalOverlay = document.querySelector('.usa-modal-overlay');

        if (modalOverlay) {
          const closeButtons = document.querySelectorAll('.usa-modal-overlay, .usa-modal--soft-gate [data-close-modal]');

          closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
              sessionStorage.setItem('softGateModal', 'closed');
              observer.disconnect(); // Stop observing when modal is closed
            });
          });
        }
      }
    });
  };

  // Set up and start the observer
  const observer = new MutationObserver(handleMutations);
  observer.observe(document.body, { childList: true, subtree: true });

  // Trigger modal opening if sessionStorage key isn't set
  if (!sessionStorage.getItem('softGateModal')) {
    window.addEventListener('load', () => softGateButton.click());
    const modal = document.querySelector('.usa-modal--soft-gate');
    modal.style.display = 'inline-block';
  }
}
